<div class="filter-tag" *ngIf="
control.value[0]  !== defaultValue[0]  
|| (control.value !== defaultValue  && !(+defaultValue[1] > 0))
|| control.value[1] !== defaultValue[1]
">

    {{title}}:

    <span [ngSwitch]="format">

        <span *ngSwitchCase="'currency'">
            &nbsp;Entre&nbsp;{{control.value[0] | currencyLocal}}&nbsp;y&nbsp;{{control.value[1] + plusValue |
            currencyLocal}}&nbsp;{{control.value[1]===this.range.max?secondaryMaxText:''}}
        </span>

        
        <span *ngSwitchCase="'percentage'">
            &nbsp;Entre&nbsp;{{control.value[0]}}%&nbsp;y&nbsp;{{control.value[1]}}%&nbsp;{{control.value[1]===this.range.max?secondaryMaxText:''}}
        </span>

        <span *ngSwitchCase="'languageLevel'">
            &nbsp;{{control.value | languageLevelNameSlider}}
        </span>

        <div *ngSwitchCase="'priorityEmployee'">
            &nbsp;{{control.value | priorityEmployeeLabelSlider}} 
        </div>

        <div *ngSwitchCase="'upperNumber'">
            &nbsp;{{control.value }} o más
        </div>
    
        <span *ngSwitchDefault>

            <ng-container *ngIf="control.value[0] === control.value[1] + plusValue">
                &nbsp;{{control.value[1] + plusValue}}{{control.value[1]===this.range.max?secondaryMaxText:''}}
            </ng-container>


            <ng-container *ngIf="control.value[0] !== control.value[1] + plusValue">
                &nbsp;Entre&nbsp;{{control.value[0] }}&nbsp;y&nbsp;{{control.value[1] +
                plusValue}}{{control.value[1]===this.range.max?secondaryMaxText:''}}&nbsp;
            </ng-container>

        </span>

    </span>

    <a (click)="onClickResetControl($event)" class="remove" title="Eliminar">×</a>



</div>
